import React from 'react'

import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { getHealthInsurerOptions } from 'modules/employees/lib/healthInsurers'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
  readonly?: boolean
}

export const HealthInsurerSelectField = observer(
  ({ dataSchemaItem, field, readonly = false }: Props) => {
    const options = React.useMemo(() => getHealthInsurerOptions(), [])

    const handleChange = React.useCallback(
      (selectedValue: unknown) => {
        field.set(selectedValue ? String(selectedValue) : '')
      },
      [field]
    )

    const currentValue = field.value ? String(field.value) : undefined

    return (
      <Selector.Popover
        label={dataSchemaItem.label} // replace by new translation
        blankLabel={i18n.t('employee_form.payroll_data.select_an_option')}
        placeholder={i18n.t('employee_form.payroll_data.select_an_option')}
        searchPlaceholder={dataSchemaItem.label}
        inputStyle="badge"
        onChange={handleChange}
        value={[currentValue]}
        isMultiSelect={false}
        isDisabled={readonly}
        mandatory={dataSchemaItem.required}
      >
        {options.map((option) => (
          <Selector.Option
            key={option.code}
            value={option.code}
            label={option.label}
            searchValue={option.searchValue}
          >
            {option.label}
          </Selector.Option>
        ))}
      </Selector.Popover>
    )
  }
)
